import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-10 text-center font-heading">社区优势</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {featuresData.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-lg p-6 md:p-8 text-center border border-background-200/70 group hover:border-primary-200/60 transition-all duration-200">
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-100/70 flex items-center justify-center group-hover:bg-primary-200/70 transition-colors">
                <i className={`${item.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}